import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { ThemeProvider as StylesThemeProvider } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { createRoot } from "react-dom/client";
import { useContext, useMemo } from "react";
import type { ReactNode } from "react";
import "./index.css";
import App from "./App";
import { createAppTheme } from "./theme";
import { ThemeModeContext, ThemeModeProvider } from "./providers/theme-mode";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./infrastructure/auth";

function ThemedApp({ children }: { children: ReactNode }) {
    const { mode } = useContext(ThemeModeContext);
    const appTheme = useMemo(() => createAppTheme(mode), [mode]);
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={appTheme}>
                <StylesThemeProvider theme={appTheme}>
                    <CssBaseline enableColorScheme />
                    {children}
                </StylesThemeProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

const themedApp = (
    <MsalProvider instance={msalInstance}>
        <ThemeModeProvider>
            <ThemedApp>
                <App />
            </ThemedApp>
        </ThemeModeProvider>
    </MsalProvider>
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(themedApp);